import { useId } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { directionFor } from '../i18n/catalog';

export default function LanguageSelector({ className = '' }) {
  const id = useId();
  const { language, languages, t, loading, saving, error, canSelect, setLanguage, retry } = useLanguage();
  if (!loading && !error && !canSelect) return null;
  return <div className={`language-selector text-sm ${className}`}>
    <label htmlFor={id} className="me-2">{t('language.label')}</label>
    <select id={id} value={languages.some(row => row.code === language) ? language : ''}
      disabled={loading || saving || !canSelect || !languages.length} onChange={event => setLanguage(event.target.value)}
      dir={directionFor(language)} className="rounded border border-slate-300 bg-white px-2 py-1 text-slate-900">
      {(loading || !languages.some(row => row.code === language)) && <option value="">{t(loading ? 'language.loading' : 'language.fallback')}</option>}
      {languages.map(row => <option value={row.code} key={row.code} lang={row.code} dir={directionFor(row.code)}>{row.name}</option>)}
    </select>
    {saving && <span role="status" className="ms-2">{t('language.saving')}</span>}
    {error && <span role="alert" className="ms-2">{t(error)} <button type="button" className="underline" onClick={retry}>{t('language.retry')}</button></span>}
  </div>;
}
